import { Injectable } from '@angular/core';
import { combineLatest, interval, merge, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from 'app/app-config';
import { ClientSystemLink, ClientSystemLinkMember } from 'app/organization/model/client-system-link';
import { DataResult, mapDataResult$ } from '@customer-apps/http/httpDataResponse';
import { ClientAuthenticationService } from '@customer-apps/user/services/client-authentication.service';
import { ConfigService } from '@customer-apps/config/config.service';
import { AppStateService } from '@customer-apps/app-state/app-state.service';

@Injectable({
  providedIn: 'root',
})
export class ClientSystemLinksService {
  constructor(
    private clientAuthenticationService: ClientAuthenticationService,
    private httpClient: HttpClient,
    private configService: ConfigService<IAppConfig>,
    private appStateService: AppStateService,
  ) {}

  getAuthenticatedClientSystemLinks(): Observable<ClientSystemLink[]> {
    return combineLatest([
      merge(this.appStateService.show, interval(180000)).pipe(
        filter(() => this.appStateService.isVisible.value === true),
        switchMap(() => this.clientAuthenticationService.getTokens()),
      ),
      this.httpClient.get<DataResult<ClientSystemLink[]>>(`${this.configService.config.apiUrl}/client-system-links`).pipe(mapDataResult$()),
    ]).pipe(
      map(([tokens, links]) => {
        return links.map((link) => {
          return {
            ...link,
            members: link.members.map((clientSystemLinkMember: ClientSystemLinkMember) => {
              const tokenForMember = tokens.find((token) => token.memberId === clientSystemLinkMember.memberId);

              let authenticatedUrl: string;
              switch (link.authenticationTokenType) {
                case 'none':
                  authenticatedUrl = clientSystemLinkMember.url;
                  break;
                case 'minimal':
                  authenticatedUrl = clientSystemLinkMember.url.replace(/__TOKEN__/, tokenForMember?.minimalToken);
                  break;
                case 'regular':
                default:
                  authenticatedUrl = clientSystemLinkMember.url.replace(/__TOKEN__/, tokenForMember?.regularToken);
                  break;
              }

              return {
                ...clientSystemLinkMember,
                url: authenticatedUrl,
              };
            }),
          };
        });
      }),
    );
  }
}
